import z from 'zod';
export const NationalitySchema = z.object({
    id: z.number().optional(),
    name: z.string().optional()
});
export const NationalityListSchema = z.object({
    highlighted: z.array(NationalitySchema),
    all: z.array(NationalitySchema)
});
//# sourceMappingURL=nationalitySchema.js.map